__turbopack_context__.v({
  "progressionBar": "rc1VhG_progressionBar",
  "progressionBarCompleted": "rc1VhG_progressionBarCompleted",
  "progressionBarContainer": "rc1VhG_progressionBarContainer",
  "visuallyHidden": "rc1VhG_visuallyHidden",
});
